// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    touch-action: none;
}

img.icon {
    vertical-align: top;
}

span.icon_large:before {
    font-size: 150%;
}

span.icon_xlarge:before {
    font-size: 175%;
}

.icon_clickable {
    cursor: pointer;
}

.icon_disabled {
    cursor: default;
    color: var(--text-color-disabled);
}

.icon_inactive {
    color: #ccc;
}`, "",{"version":3,"sources":["webpack://./components/style/Icon.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf","sourcesContent":[".icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    touch-action: none;\n}\n\nimg.icon {\n    vertical-align: top;\n}\n\nspan.icon_large:before {\n    font-size: 150%;\n}\n\nspan.icon_xlarge:before {\n    font-size: 175%;\n}\n\n.icon_clickable {\n    cursor: pointer;\n}\n\n.icon_disabled {\n    cursor: default;\n    color: var(--text-color-disabled);\n}\n\n.icon_inactive {\n    color: #ccc;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
